import { render, staticRenderFns } from "./User-message.vue?vue&type=template&id=9de7824a&"
import script from "./User-message.vue?vue&type=script&lang=js&"
export * from "./User-message.vue?vue&type=script&lang=js&"
import style0 from "./User-message.vue?vue&type=style&index=0&lang=scss&spaced=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports